export default {
  name: 'rb-dynamic-swiper-slide',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    activeSlideIndex: {
      type: Number,
      default: 0,
    },
  },
  render(createElement) {
    const filteredSlots = this.$slots.default.filter((slot) => !!slot.tag)
    const currentSlot = filteredSlots[this.index]
    return createElement(
      'swiper-slide',
      {
        props: {
          isActiveSlide: this.index === this.activeSlideIndex,
          index: this.index,
        },
      },
      [currentSlot]
    )
  },
}
